import RestApiModel from "@/api/Model/RestApiModel";

class UserInformation extends RestApiModel {
  static getResourceEndpoint() {
    return '/UserRoles';
  }
}

export default UserInformation;
